import { render, staticRenderFns } from "./TarotShuffleForm.vue?vue&type=template&id=66b6ef5f&scoped=true&"
import script from "./TarotShuffleForm.vue?vue&type=script&lang=js&"
export * from "./TarotShuffleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66b6ef5f",
  null
  
)

export default component.exports